import { useCallback } from 'react'
import {
  ApiGetWithToken,
	ApiDeleteWithToken,
	ApiPostWithToken,
	useApiFetch,
	useApiPost,
	ApiPostNoToken
} from 'shared/api'
import {
  inviteApi,
  inviteApiBy,
	registerApi
} from 'interface/endpoints'
import {
	InviteApplovalFormData,
	InviteFormData,
  InviteRejectFormData,
  InviteRequestFormData,
  InviteResult,
  InviteResultList,
} from './types'
import { CancelToken } from 'axios'

export * from './types'

export const useListInvite = (
) => useApiFetch(
  useCallback(
    (apiAccess, cancelToken) => {
			return ApiGetWithToken<InviteResultList>(
        apiAccess,
        inviteApi('/list'),
        cancelToken
      )
    },
    []
  )
)

export const useGetInvite = (
  inviteId?: number | null
) => useApiFetch(
	useCallback(
		(apiAccess, cancelToken) => {
      if (!inviteId) return null
      return ApiGetWithToken<InviteResult>(
        apiAccess,
        inviteApiBy(inviteId),
        cancelToken
  		)
    },
		[inviteId]
	)
)

export const PostInviteRequest = (
	domain: string,
	form: InviteRequestFormData,
	cancelToken?: CancelToken
) => ApiPostNoToken<string>(
	registerApi(domain, `/request`),
	form,
	cancelToken
)

export const usePostInviteApploval = (
  callback?: {
    onPosted?: (inviteId: number) => void
    onError?: (reason: Error | undefined) => void
  }
) => useApiPost<{ inviteId: number, form: InviteApplovalFormData }, number>(
	useCallback(
		(apiAccess, cancelToken, { inviteId, form }, webSocketId) => {
			return ApiPostWithToken(
				apiAccess,
        inviteApiBy(inviteId, '/apploval'),
				form,
				cancelToken,
				webSocketId
			)
		},
		[]
	),
	useCallback(
		(result) => {
			if (callback?.onPosted) callback.onPosted(result)
			return result
		},
		[callback]
	),
	useCallback(
		(reason) => {
      if (callback?.onError) callback?.onError(reason)
		},
		[callback]
	)
)

export const usePostInviteReject = (
  callback?: {
    onPosted?: (inviteId: number) => void
    onError?: (reason: Error | undefined) => void
  }
) => useApiPost<{ inviteId: number, form: InviteRejectFormData }, number>(
	useCallback(
		(apiAccess, cancelToken, { inviteId, form }, webSocketId) => {
			return ApiPostWithToken(
				apiAccess,
        inviteApiBy(inviteId, '/reject'),
				form,
				cancelToken,
				webSocketId
			)
		},
		[]
	),
	useCallback(
		(result) => {
			if (callback?.onPosted) callback.onPosted(result)
			return result
		},
		[callback]
	),
	useCallback(
		(reason) => {
      if (callback?.onError) callback?.onError(reason)
		},
		[callback]
	)
)

export const usePostInvite = (
  callback?: {
    onPosted?: (result: InviteResult) => void
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    onError?: (reason: any) => void
  }
) => useApiPost<InviteFormData, InviteResult>(
	useCallback(
		(apiAccess, cancelToken, form, webSocketId) => {
			return ApiPostWithToken(
				apiAccess,
        inviteApi(),
				form,
				cancelToken,
				webSocketId
			)
		},
		[]
	),
	useCallback(
		(result) => {
			if (callback?.onPosted) callback.onPosted(result)
			return result
		},
		[callback]
	),
	useCallback(
		(reason) => {
      if (callback?.onError) callback?.onError(reason)
		},
		[callback]
	)
)

export const useDeleteInvite = (
  callback?: {
    onDeleted?: (inviteId: number) => void
    onError?: (reason: Error | undefined) => void
  }
) => useApiPost<number, number>(
	useCallback(
		(apiAccess, cancelToken, inviteId, webSocketId) => {
			return ApiDeleteWithToken(
				apiAccess,
        inviteApiBy(inviteId),
				cancelToken,
				webSocketId
			)
		},
		[]
	),
	useCallback(
		(result) => {
			if (callback?.onDeleted) callback.onDeleted(result)
			return result
		},
		[callback]
	),
	useCallback(
		(reason) => {
      if (callback?.onError) callback?.onError(reason)
		},
		[callback]
	)
)

export const useExtendInvite = (
  callback?: {
    onPosted?: (result: InviteResult) => void
    onError?: (reason: Error | undefined) => void
  }
) => useApiPost<number, InviteResult>(
	useCallback(
		(apiAccess, cancelToken, inviteId, webSocketId) => {
			return ApiPostWithToken<InviteResult>(
				apiAccess,
        inviteApiBy(inviteId, "/extend"),
				undefined,
				cancelToken,
				webSocketId
			)
		},
		[]
	),
	useCallback(
		(result) => {
			if (callback?.onPosted) callback.onPosted(result)
			return result
		},
		[callback]
	),
	useCallback(
		(reason) => {
      if (callback?.onError) callback?.onError(reason)
		},
		[callback]
	)
)